import {resultParamsActionCreator} from "~/actions/result_param_actions";
import { getField, getModelTree, getFieldData, getRelationshipFieldsByModelName, getEditFieldData, getFieldValue} from "~/stateGetter";
import { setAutoCompleteInvalidated } from "~/rx/model/fieldOptions";

import normalizeFieldValue from "~/data/normalizeFieldValue";

import identify from "~/identify";


export const MODEL_ACTIONS = {
    CHANGE_GROUP_OPEN: 'change_group_open',

    CHANGE_FIELD_VALUE: 'change_field_value',
    CHANGE_SELECT_QUERY: 'change_select_query',
    UPDATED_SELECTED_ROWS: 'update_selected_rows',
    CHANGE_SELECT_OPTIONS: 'change_select_options',
    CHANGE_ACTIVE_ITEM: 'change_active_item',
    CHANGE_FIELD_GROUP_OPEN: 'change_field_group_open',
    HIDE_MESSAGES: 'hide_messages',
    SET_DEFAULT_ITEM: 'set_default_item',
    SET_NEW_ITEM: 'set_new_item',

    INVALIDATE_SUBVIEWS: 'invalidate_subviews',
    SET_ACTIVE_RELATIONSHIP_FIELD: 'set_active_relationship_field',
    SET_ACTIVE_RELATIONSHIP_ITEM_ID: 'set_active_relationship_item_id',
};

export function modelActionsCreator(modelId, modelName, dispatch = (a) => a) {
    const hideMessages = () => ({ type: MODEL_ACTIONS.HIDE_MESSAGES, modelId });

    return {
        hideMessages,
        ...resultParamsActionCreator({modelId}, dispatch),

        /**
         * Changes a fields value and changes adapters values accordingly, dispatching a changeFieldValue for every one of them
         *
         * @param fieldName
         * @param inputType
         * @param value
         * @returns {function(*, *)}
         */
        changeFieldValue: (fieldName, inputType, value, fieldProps = {}) => {
            return {
                type: MODEL_ACTIONS.CHANGE_FIELD_VALUE,
                inputType,
                fieldName,
                value,
                modelId,
                ...fieldProps
            };
        },


        changeFieldQuery: (fieldName, inputType, query) => dispatch({
            type: MODEL_ACTIONS.CHANGE_SELECT_QUERY,
            fieldName,
            inputType,
            query,
            modelId
        }),

        updateSelectedRows: ({ rowIds, selectThroughout }) => dispatch({
            type: MODEL_ACTIONS.UPDATED_SELECTED_ROWS,
            ids: rowIds,
            selectThroughout,
            modelId
        }),

        resetItemValue: () => {
            return { type: MODEL_ACTIONS.SET_DEFAULT_ITEM, modelId };
        },

        setNewItem: () => {
            return { type: MODEL_ACTIONS.SET_NEW_ITEM, modelId };
        },

        // filter actions
        changeGroupOpen: (filterGroupName, open) => settingsActionCreator(modelId).changeGroupOpen(filterGroupName, open),

        // filter actions
        changeFilterOpen: (filterGroupName, filterName, open) => settingsActionCreator(modelId).changeFilterOpen(filterGroupName, filterName, open),

        resetFilters: () => settingsActionCreator(modelId).resetFilters(),

        invalidateSubviews: () => {
            return {
                type: MODEL_ACTIONS.INVALIDATE_SUBVIEWS,
                modelId,
            }
        },

        // field shit
        changeFieldGroupOpen: (fieldGroupName, open) => dispatch({
            type: MODEL_ACTIONS.CHANGE_FIELD_GROUP_OPEN,
            open,
            fieldGroupName,
            modelId
        }),

        resetRelationshipField: () => (dispatch, getState) => {
            const state = getState();
            const parentModel = getModelTree(state).getParentModel(modelId);
            if (!parentModel?.activeRelationshipField) return;

            dispatch(modelActionsCreator(parentModel.modelId).invalidateRelationAutocompleteByModelId())

            dispatch({
                type: MODEL_ACTIONS.SET_ACTIVE_RELATIONSHIP_FIELD,
                parentModelId: parentModel.modelId,
                modelId,
                fieldName: null,
            });
        },

        setRelationshipField: (relationshipFieldName, inputType, id) => (dispatch, getState) => {
            const state = getState();
            const field = getFieldData(state, modelId, inputType, relationshipFieldName);

            const relationshipModel = getModelTree(state).getChildren(modelId).find(model => {
                return model.modelName === field.model && model.hasForeignFieldRelation
            });

            if (!relationshipModel) return;

            const {canCreate} = getField(getState(), modelId, inputType, relationshipFieldName).field;
            if (!canCreate) return;

            dispatch(modelActionsCreator(relationshipModel.modelId).resetItemValue());

            dispatch({
                type: MODEL_ACTIONS.SET_ACTIVE_RELATIONSHIP_FIELD,
                fieldName: relationshipFieldName,
                modelId: relationshipModel.modelId,
                parentModelId: modelId,
                itemId: id,
            });

            if (!id) {
                dispatch({ type: MODEL_ACTIONS.SET_NEW_ITEM, modelId: relationshipModel.modelId, });
            }
        },

        setRelationshipValue: (nextValue, remove = false) => (dispatch, getState) => {
            nextValue = +nextValue;
            const state = getState();
            const parentModel = getModelTree(state).getParentModel(modelId);
            if (!parentModel?.activeRelationshipField) return;

            const {name , hasMultipleValues, type} = getEditFieldData(state, parentModel.modelId, parentModel.activeRelationshipField.name);
            let value = getFieldValue(state, parentModel.modelId, identify.EDITFIELD, name)?.value;

            if (remove)  value = hasMultipleValues ? [].concat(value).filter((v) => v !== nextValue) : null;
            else  value = hasMultipleValues ? ([value, nextValue].flat().filter(Boolean)) : nextValue;

            value = normalizeFieldValue(identify.EDITFIELD, type, value);
            value = hasMultipleValues ? Array.from(new Set([].concat(value))) : value;

            const parentModelActions = modelActionsCreator(parentModel.modelId);
            dispatch(parentModelActions.changeFieldValue(name, identify.EDITFIELD, value));
            dispatch(parentModelActions.invalidateRelationAutocompleteByModelId());
        },

        invalidateRelationAutocompleteByModelId: () => (dispatch, getState) => {
            const state = getState();
            const { modelName, activeRelationshipField } = getModelTree(state).getModel(modelId);

            if (!activeRelationshipField) return;
    
            getRelationshipFieldsByModelName(state, modelName).filter((field) => {
                if (activeRelationshipField.model !== field.model) return;
                dispatch(setAutoCompleteInvalidated(field.name, modelId, identify.EDITFIELD));
            })
        }
    };
}